import React, { useEffect, useState } from "react";
import { showSalary } from "../../../../utilities/showsalary";
import bgphoto from "../../../../../src/assets/img/images/teamanics_logo.png";
import orgImage from "../../../../../src/assets/img/images/office.jpeg";
import { ProfileService } from "../../../../services/ProfileService";
import { Link, useLocation } from "react-router-dom";
import { Col, Row } from "reactstrap";
import TeamanicsButton from "../../../../buttoncomponent/TeamanicsButton";
import { Stringutility } from "../../../../utilities/stringutility";

const JobDetails = () => {
  const [jobtitle, setjobtitle] = useState([]);
  const [accountname, setaccountname] = useState([]);
  const [jobs, setJobs] = useState({});
  const [benefits, setBenefits] = useState([]);
  const [logo, setLogo] = useState("");
  const [backGroundImage, setBackGroundImage] = useState("");
  const [showPay, setshowpay] = useState(false);

  const location = useLocation();
  const receivedData = location.state;
  var jobId = "";
  if (!Stringutility.isNullOrEmpty(receivedData)) {
    jobId = receivedData.jobId;
  }

  const jobIdObj = { jobId: jobId };
  const back = () => {};
  const getJobBenefits = (moBenefits) => {
    const bList = [];
    if (moBenefits != null) {
      if (moBenefits.cobra == true) {
        bList.push("Cobra");
      }

      if (moBenefits.Disability == true) {
        bList.push("Disability");
      }

      if (moBenefits.medicalLeave == true) {
        bList.push("Medical Leave");
      }

      if (moBenefits.minimumWage == true) {
        bList.push("Minimum Wage");
      }

      if (moBenefits.overtime == true) {
        bList.push("Overtime");
      }

      if (moBenefits.unEmploymentBenefit == true) {
        bList.push("Unemployment Benefits");
      }

      if (moBenefits.WorkerCompensation == true) {
        bList.pushd("Workers Compensation");
      }

      if (moBenefits.bonusPay == true) {
        bList.push("Bonus Pay");
      }

      if (moBenefits.compensation401k == true) {
        bList.push("401k");
      }

      if (moBenefits.stockOption == true) {
        bList.push("Stock options");
      }

      if (moBenefits.health == true) {
        bList.push("Helth");
      }

      if (moBenefits.dental == true) {
        bList.push("Dental");
      }

      if (moBenefits.vision == true) {
        bList.push("Vision");
      }

      if (moBenefits.lifeInsurance == true) {
        bList.push("Life Insurance");
      }

      if (moBenefits.paidHoliday == true) {
        bList.push("Paid Holidays");
      }

      if (moBenefits.paidSickTime == true) {
        bList.push("Paid Sick Time");
      }

      if (moBenefits.paidVacation == true) {
        bList.push("Paid Vacation");
      }

      if (moBenefits.flexibleHour == true) {
        bList.push("Flexible Hours");
      }

      if (moBenefits.parentalLeave == true) {
        bList.push("Parental Leave");
      }

      if (moBenefits.empDiscount == true) {
        bList.push("Employee Discounts");
      }

      if (moBenefits.profDeveAssistance == true) {
        bList.push("Professional Development Assistance");
      }
      if (moBenefits.tuition == true) {
        bList.push("Tuition");
      }
      setBenefits(bList);
    }
  };

  let count = 0;
  useEffect(() => {
    if (Stringutility.getValue(jobId) != "") {
      getjobdetails();
    }
  }, [count]);

  const getjobdetails = () => {
    const regex = /(<([^>]+)>)/gi;
    ProfileService.getAppliedJobdetails(jobId).then((response) => {
      try {
        if (response.data !== null) {
          var appliedjobdetails = response.data;
          const jobResponseDetails = appliedjobdetails.jobResponse;
          if (jobResponseDetails !== null) {
            setJobs(jobResponseDetails);
            let title = jobResponseDetails.title;
            setjobtitle(Stringutility.getValue(title));

            const accountDetails = jobResponseDetails.account;
            if (accountDetails != null) {
              let logo = accountDetails.logo;
              let bgImage = accountDetails.bgImage;
              let name = accountDetails.name;

              setLogo(Stringutility.getValue(logo));
              setBackGroundImage(Stringutility.getValue(bgImage));
              setaccountname(Stringutility.getValue(name));
            }

            const jobBenifits = jobResponseDetails.jobBenefits;
            if (jobBenifits != null) {
              getJobBenefits(jobBenifits);
            }

            const location = jobResponseDetails.location;
            if (location !== null) {
              const locationAddress = location.address;
              if (locationAddress != null) {
                let city = locationAddress.city;
                let state = locationAddress.state;
              }
            }
            if (appliedjobdetails.jobResponse.showPay) {
              setshowpay(appliedjobdetails.jobResponse.showPay);
            }
            if (!Stringutility.isNullOrEmpty(appliedjobdetails.jobResponse.jobDescription)) {
              const result =
                appliedjobdetails.jobResponse.jobDescription.replace(regex, "");
            }

            if (!Stringutility.isNullOrEmpty(appliedjobdetails.jobResponse.jobRequirements)) {
              const result =
                appliedjobdetails.jobResponse.jobRequirements.replace(
                  regex,
                  ""
                );
            }
            if (
              !Stringutility.isNullOrEmpty(appliedjobdetails.jobResponse.jobResponsibilities)
            ) {
              const result =
                appliedjobdetails.jobResponse.jobResponsibilities.replace(
                  regex,
                  ""
                );
            }
          }
        }
      } catch (err) {
        console.error("getAppliedJobdetails" + JSON.stringify(err));
      }
    });
  };
  const displayLocation = (location) => {
    var arr = [];
    if (!Stringutility.isNullOrEmpty(location.city)) {
      arr.push(location.city);
    }
    if (!Stringutility.isNullOrEmpty(location.state)) {
      arr.push(location.state);
    }
    if (!Stringutility.isNullOrEmpty(location.zipcode)) {
      arr.push(location.zipcode);
    }
    return arr.join(", ");
  };

  const displaySalary = (jobs) => {
    return (
      <>
        {!Stringutility.isNullOrEmpty(jobs.salaryMin) ? (
          !Stringutility.isNullOrEmpty(jobs.salaryMax) ? (
            <>
              ${showSalary(jobs.salaryMin)}
              {"-"}${showSalary(jobs.salaryMax)}
            </>
          ) : (
            <>${showSalary(jobs.salaryMin)}</>
          )
        ) : !Stringutility.isNullOrEmpty(jobs.salaryMax) ? (
          <>${showSalary(jobs.salaryMax)}</>
        ) : (
          <></>
        )}
      </>
    );
  };

  const showSalaryType = (salaryType) => {
    if (!Stringutility.isNullOrEmpty(salaryType)) {
      if (salaryType.key === "HOURLY") {
        return "hour";
      }
      if (salaryType.key === "ANNUAL") {
        return "year";
      }
      if (salaryType.key === "MONTHLY") {
        return "month";
      }
      return salaryType.value;
    }
  };

  const checkJobSalary = (jobResponse) => {
    if (jobResponse !== null) {
      let salaryMin = jobResponse.salaryMin;
      let salaryMax = jobResponse.salaryMax;
      let salaryType = jobResponse.salaryType;
      if (salaryMin == 0 && salaryMax == 0) {
        return <></>;
      } else if (salaryMin !== 0 && salaryMax == 0) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else if (salaryMin == 0 && salaryMax !== 0) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {"$" + showSalary(salaryMax, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else if (salaryMin == salaryMax) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {"$" +
              showSalary(salaryMin, salaryMin, salaryMax) +
              "-" +
              "$" +
              showSalary(salaryMax, salaryMin, salaryMax)}
            /{showSalaryType(salaryType)}{" "}
          </div>
        );
      }
    }
  };

  function changeTab(index) {
    var tabButtons = document.getElementById("tab-buttons").children;
    var tabPanels = document.getElementById("tab-panels").children;

    // Remove the active utility classes from all tabs (bg-white, text-blue-600)
    // And hide all tab content (with the "hidden" utility)
    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("text-primary-white");
      tabButtons[i].classList.remove("bg-primary-blue");
      tabButtons[i].classList.add("text-primary-blue");
      tabPanels[i].classList.add("hidden");
    }

    // Add the active utility classes to the currently active tab (bg-white, text-blue-600)
    // And show the current tab content (remove the "hidden" utility)
    tabButtons[index].classList.remove("text-primary-blue");
    tabButtons[index].classList.add("text-primary-white");
    tabButtons[index].classList.add("bg-primary-blue");
    tabPanels[index].classList.remove("hidden");
  }

  return (
    <>
      <header className="min-sm:fixed min-sm:top-0 min-sm:left-0 min-sm:w-screen "></header>

      <h1
        className="JobDetails text-2xl text-primary-dark 
                max-sm:text-center max-sm:text-primary-white
                t-max-sm:-mt-14 max-sm:ml-4 col-span-full
                min-sm:mt-20 min-sm:ml-5 min-md:mt-0 min-md:ml-0
                "
      >
        <Row>
          <Col className=" font-bold ">Job Details</Col>
          <Col>
            {" "}
            <div className=" pr-3 back-button-style  ">
              <Link to="">
                <span onClick={() => back()}>
                  <TeamanicsButton>
                    Back
                  </TeamanicsButton>
                </span>
              </Link>
            </div>
          </Col>
        </Row>
      </h1>

      {/* Job Overview Section  */}
      <div
        className="jobOverview 
                    min-md:col-span-full min-lg:col-span-2 min-2xl:col-span-1 max-md:col-span-full
                    order-2 max-md:px-5
                    "
      >
        {/* Job Details Wrapper  */}
        <div className="jobSuggestions_wrapper flex w-full  min-sm:flex-wrap min-sm:flex-col max-sm:flex-row ">
          {/*Job Detail Section */}
          <div
            href="#"
            className="jobSuggestion flex flex-col  bg-primary-white min-sm:shadow-lg rounded-xl overflow-hidden min-md:border min-md:border-primary-gray2 max-sm:min-w-[350px] max-sm:flex-wrap max-sm:flex-col "
          >
            <div className="jobsuggestion_logo relative min-sm:w-full min-sm:basis-1/3 flex items-start overflow-hidden bg-primary-white  min-sm:h-[260px] max-sm:h-fit">
              {!Stringutility.isNullOrEmpty(backGroundImage) ? (
                <img
                  className="w-full min-sm:h-[320px] "
                  src={backGroundImage}
                  alt="Company "
                />
              ) : (
                <img
                  className="w-full min-sm:h-[320px] "
                  src={orgImage}
                  alt="Company "
                />
              )}
              
              <div className="myjob_company h-[64px] w-[64px] items-center border-primary-gray2 border rounded-lg p-1 max-w-[64px] mt-[10px] ml-[10px] bg-white shadow-4xl absolute flex">
                {!Stringutility.isNullOrEmpty(logo) ? (
                  <img className="w-full h-auto" src={logo} alt="Company" />
                ) : (
                  <img className="w-full h-auto" src={bgphoto} alt="Company" />
                )}
              </div>
            </div>
            <div className="min-sm:basis-2/3 flex flex-col gap-2 max-sm:flex max-sm:gap-3 py-4 px-7 ">
              <div className="jobsuggestion_info col-span-2  max-sm:basis-2/3 max-sm:order-1">
                <div className="text-lg font-bold  text-primary-blue pb-0">
                  {" "}
                  {jobtitle}
                </div>

                {!Stringutility.isNullOrEmpty(accountname) && (
                  <div className="text-primary-dark  font-semibold text-sm">
                    {accountname}
                  </div>
                )}
                {!Stringutility.isNullOrEmpty(jobs.location) &&
                  !Stringutility.isNullOrEmpty(jobs.location.address) && (
                    <div className="text-Gray-600  font-normal text-sm">
                      {displayLocation(jobs.location.address)}
                    </div>
                  )}
              </div>

              <div className="jobsuggestion_pay min-sm:col-span-2 max-sm:order-3 max-sm:basis-4/5">
                {showPay === true ? <>{checkJobSalary(jobs)}</> : <></>}

                <div className="block">
                  {benefits.length > 0 && (
                    <div className="block">
                      {benefits.map((benefit, index) => {
                        return (
                          <span
                            className="inline-block mb-1 bg-Gray-600 font-semibold text-white text-xs rounded-[4px] mr-1 px-2 pb-[2px]"
                            key={index}
                          >
                            {benefit}
                          </span>
                        );
                      })}
                    </div>
                  )}
               
                </div>
              </div>

              <div className="fitscore min-sm:col-span-1 hidden min-sm:row-start-1 min-sm:col-start-4 min-sm:mr-4 bg-primary-dark rounded-full w-[70] h-[70] text-white text-center max-sm:order-2 max-sm:basis-1/6 max-sm:ml-8">
                <div className="blue bg-primary-blue rounded-full w-[65] h-[65] m-[2]">
                  <div className="gray bg-primary-gray inline-block rounded-full  w-[60] h-[60] m-[3]">
                    <div className="navyblue bg-primary-dark rounded-full w-[60] h-[60] pt-3 font-semibold text-[10px]">
                      {" "}
                      Fit Score <br />
                      <div className="span1 text-xl font-normal text-white text-[20px]">
                        4.3
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Job Detail Section End */}
        </div>
        {/* Job Details Wrapper End  */}
      </div>
      {/* Job Overview End  */}

      {/* Job Description Start  */}
      <div
        className="JobDescription 
                        min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
                        order-3 max-md:px-5
                        "
      >
        {/*Tabs Container */}
        <div className="tabs rounded-xl overflow-hidden ">
          {/*The wrapper of tabs */}
          <div className="drop-shadow-lg">
            {/*Tab Buttons */}
            <div
              id="tab-buttons"
              className="flex max-md:flex-col max-md:gap-2 max-md:w-[97%]  "
            >
              <Link
                to={{ pathname: "/jobdetails", state: jobIdObj }}
                onClick={() => changeTab(0)}
                className="inline-block min-sm:px-4 min-xl:px-8 py-3 max-sm:px-3 max-sm:py-1 
                                                        text-primary-white font-semibold t-border-width bg-primary-blue t-border-primary-blue 
                                                        mr-1 rounded-tl-xl"
              >
                Job Description
              </Link>

              <Link
                to={{ pathname: "/jobdetails", state: jobIdObj }}
                onClick={() => changeTab(1)}
                className="inline-block min-sm:px-4 min-xl:px-8 py-3 max-sm:px-3 max-sm:py-1 
                                                        text-primary-blue font-semibold t-border-width t-border-primary-blue 
                                                        mr-1"
              >
                Responsibilities
              </Link>
              <Link
                to={{ pathname: "/jobdetails", state: jobIdObj }}
                onClick={() => changeTab(2)}
                className="inline-block min-sm:px-4 min-xl:px-8 py-3 max-sm:px-3 max-sm:py-1 
                                                    text-primary-blue font-semibold t-border-width t-border-primary-blue"
              >
                Requirements
              </Link>
            </div>

            {/*Tab Panels */}
            <div
              id="tab-panels"
              className="bg-white px-12 pt-4 pb-7 t-border-width t-border-primary-blue rounded-b-xl rounded-tr-xl -mt-[1px] shadow-lg "
            >
              {/*Job Description */}
              <div className="jobBox rounded-2xl">
                <div className="text-base pt-5">
                  {!Stringutility.isNullOrEmpty(jobs.jobDescription) && (
                    <p
                      className="pb-2"
                      dangerouslySetInnerHTML={{ __html: jobs.jobDescription }}
                    ></p>
                  )}
                </div>
              </div>
              {/*End of Job Description */}

              {/*Job Responsibilities */}
              <div className="jobBox hidden rounded-2xl">
                <div className="text-base pt-5">
                  <ul className="marker:text-primary-blue list-caretright list-outside ">
                    {!Stringutility.isNullOrEmpty(jobs.jobResponsibilities) && (
                      <p
                        className="pb-2"
                        dangerouslySetInnerHTML={{
                          __html: jobs.jobResponsibilities,
                        }}
                      ></p>
                    )}{" "}
                  </ul>
                </div>
              </div>
              {/*End of Job Responsibilities */}

              {/*Job Requirements */}
              <div className="jobBox hidden rounded-2xl">
                <div className="text-base pt-5">
                  <ul className="marker:text-primary-blue list-caretright list-outside ">
                    {!Stringutility.isNullOrEmpty(jobs.jobRequirements) && (
                      <p
                        className="pb-2"
                        dangerouslySetInnerHTML={{
                          __html: jobs.jobRequirements,
                        }}
                      ></p>
                    )}
                  </ul>
                </div>
              </div>
              {/*End of Job Requirements */}             
            </div>
            {/*End of Tab Panels */}
          </div>
        </div>
        {/*End of Tabs Container */}
        <button
          type="submit"
          className="apply min-sm:hidden bg-primary-blue rounded-full text-[16px] text-white font-semibold text-center my-2 inline-block px-5 pt-2 pb-3 col-start-1 w-[120px] max-sm:order-last"
        >
          {/* Apply */}
        </button>
        {/*Job Description Section End*/}
      </div>
      {/* Job Description End  */}
    </>
  );
};

export default JobDetails;
